import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getHoldReasons, putOnHold, putOffHold } from "requests/onHold";
import { putWestAmcOnHold, putWestAmcOffHold } from "requests/westAmc";
import { CASE_HOLD_UPDATE } from "typeConstants/rights";
import Message from "components/Homeowner/CaseForms/Actions/OnHold/Mueller/CaseNote";
import { MSpinner, MCollapsibleCard } from "components/Shared";

export const ON_HOLD_TAB_ID = "ON_HOLD_TAB_ID";
export const ON_HOLD_MESSAGE_TAB_ID = "ON_HOLD_MESSAGE_TAB_ID";

const WestAmcOnHold = ({
  controlNumber,
  canUpdateOnHold,
  openCaseActionTab,
  closeTab,
  internetUserId,
}) => {
  const [fetchingHoldStatus, setFetchingHoldStatus] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isOnHold, setIsOnHold] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    getHoldInfo();
    return () => {
      mounted.current = false;
    };
  }, []);

  const getHoldInfo = () => {
    setFetchingHoldStatus(true);
    getHoldReasons(controlNumber, handleStatus, handleStatusError, mounted);
  };

  const handleStatus = (response) => {
    setIsOnHold(!!response);
    setFetchingHoldStatus(false);
  };
  const handleStatusError = () => setFetchingHoldStatus(false);

  const handleOnHoldClick = () => {
    if (isOnHold) {
      putOffHold(controlNumber, internetUserId, onHoldChangedCallback, onHoldChangedCallback, mounted);
      putWestAmcOffHold(controlNumber, () => {}, () => {}, mounted);
    } else {
      putOnHold(controlNumber, internetUserId, null, null, onHoldChangedCallback, onHoldChangedCallback, mounted);
      putWestAmcOnHold(controlNumber, () => {}, () => {}, mounted);
    }
  };

  const handleMessageClick = () => {
    openCaseActionTab(
      <Message onSuccessCallback={onMessageCallback} />,
      "Case Note",
      ON_HOLD_MESSAGE_TAB_ID
    );
  };

  const onHoldChangedCallback = () => {
    setFetchingHoldStatus(true);
    getHoldInfo();
  };

  const onMessageCallback = () => {
    closeTab(ON_HOLD_MESSAGE_TAB_ID);
  };

  if (fetchingHoldStatus) {
    return <MSpinner />;
  }

  const statusContent = (
    <h4>
      <b>Status: </b> {`${isOnHold ? "On Hold" : "Off Hold"} `}
      <IconButton size="small" title="Refresh Status" onClick={getHoldInfo}>
        <RefreshIcon />
      </IconButton>
    </h4>
  );

  return (
    <MCollapsibleCard
      title="West AMC On Hold Actions"
      expanded={expanded}
      onExpandedChange={setExpanded}
      persistentContent={statusContent}
      styledHeader={false}
      wrapperClassName=""
    >
      <span className={"case-action"}>
        <Button
          id="on-hold-action-button"
          onClick={handleOnHoldClick}
          disabled={!canUpdateOnHold || isOnHold}
        >
          On Hold
        </Button>
      </span>
      <span className={"case-action"}>
        <Button
          id="off-hold-action-button"
          onClick={handleOnHoldClick}
          disabled={!canUpdateOnHold || !isOnHold}
        >
          Off Hold
        </Button>
      </span>
      <span className={"case-action"}>
        <Button
          id="message-action-button"
          onClick={handleMessageClick}
        >
          Add Case Note
        </Button>
      </span>
    </MCollapsibleCard>
  );
};

WestAmcOnHold.propTypes = {
  controlNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  caseHeader: PropTypes.object,
  canUpdateOnHold: PropTypes.bool,
  onHoldReasons: PropTypes.array,
  isFetchingHoldReasons: PropTypes.bool,
  openCaseActionTab: PropTypes.func, // Tab control method used to open a new tab
  closeTab: PropTypes.func,  // Tab control method that is called with a tab id to close the tab
  internetUserId: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    controlNumber: state.caseDetails.controlNumber,
    caseHeader: state.caseForms.caseHeader,
    canUpdateOnHold: state.user.profile.rights.includes(CASE_HOLD_UPDATE),
    internetUserId: state.user.profile.internetUserId,
  };
};

export default connect(mapStateToProps)(WestAmcOnHold);